import { PrinterOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import Loadercomponent from "../../../../Componets/Loader";
import toast from "react-hot-toast";
import { get_material_issue } from "../../../../Controllers/Purchases/MaterialIssue";
import URL from "../../../../Main/url";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const MaterialIssueView = () => {
  let componentRef = useRef();
  let { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [details, setDetails] = useState();
  const [displayData, setDisplayData] = useState();

  const fetchData = async () => {
    setLoader(true);

    let data = {
      id: id,
    };

    let issue = await get_material_issue(data);
    if (issue?.status) {
      setDetails(issue?.data);
      setDisplayData(issue?.data);
      setLoader(false);
    } else {
      toast?.error(issue?.message);
      setLoader(false);
    }
  };

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A4;
        margin: 6% 6% 16% 6%;
      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  useEffect(() => {
    if (displayData?.branch?.name) {
      injectScopedStyles();
    }
  }, [displayData?.branch?.name]);

  const getDisplayData = () => {
    return displayData || details;
  };

  const data = getDisplayData();

  return (
    <div className="p-4">
      <Loadercomponent loader={loader}>
        <div className="flex justify-center">
          <div className="w-[8.27in] text-right py-4">
            <ReactToPrint
              trigger={() => (
                <div className="">
                  <PrinterOutlined className="text-2xl" />
                </div>
              )}
              content={() => componentRef}
            />
          </div>
        </div>
        <div className="px-24">
          <div className="" ref={(el) => (componentRef = el)}>
            <div>
              <div className="text-black-900 text-[0.65rem] text-center">
                <div className="text-center">
                  {data?.branch?.image ? (
                    <div className="flex justify-center">
                      <div className="text-xl pb-2">
                        <img
                          className="w-[50px] h-[50px]"
                          src={`${URL}/uploads${data?.branch?.image}`}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="text-medium text-xl">
                    {data?.branch?.name}
                  </div>
                </div>
              </div>
              <div className="text-black-900 text-[0.65rem] text-center pt-4">
                <span>Email : {data?.branch?.email || ""}</span>
                <span>Phone : {data?.branch?.phone || ""}</span>
                <div>
                  {data?.branch?.area || ""} {data?.branch?.city || ""}{" "}
                  {data?.branch?.country || ""}
                </div>
                <div>VATIN : {data?.branch?.tax || "N/A"}</div>
              </div>
              <hr className="my-4 border-t-black-900 border-black" />
              <div className="text-medium text-xl text-center">
                MATERIAL ISSUE NOTE
              </div>
              <div className="text-[0.60rem] pb-6">
                <div className="flex justify-between">
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td>Issue To : {data?.request?.department || ""}</td>
                        </tr>
                        <tr>
                          <td>Request No : #REQ-{data?.request?.number || ""}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td>Issue No</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            #ISSUE-{data?.number}
                          </td>
                        </tr>
                        <tr>
                          <td>Date</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            {formatDateDDMMYYYY(data?.date)}
                          </td>
                        </tr>
                        <tr>
                          <td>Issue Date</td>
                          <td className="px-2">:</td>
                          <td className="text-right">
                            {formatDateDDMMYYYY(data?.issue_date)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="">
                <table className="w-full">
                  <thead className="bg-black">
                    <tr className="text-[0.60rem]">
                      <th className="font-normal text-white text-left py-2 pl-3">
                        S.NO
                      </th>
                      <th className="font-normal text-white text-left p-2">
                        DESCRIPTION
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        UNIT
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        REQ.QTY
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        ISSUED.QTY
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        PRICE
                      </th>
                      <th className="font-normal text-white text-center p-2">
                        VAT
                      </th>
                      <th className="font-normal text-white text-right pr-2">
                        TOTAL
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    {data?.details?.map((value, index) => {
                      return (
                        <tr className="uppercase border-b border-gray-300" key={value?._id}>
                          <td className="text-[0.60rem] leading-[0.75rem] align-top">
                            <div className="pl-3">{index + 1}</div>
                          </td>
                          <td className="text-left leading-[0.75rem] align-top">
                            <div className="text-[0.60rem] p-0 m-0 text-medium">
                              {value?.name}
                            </div>
                            <div className="text-gray-500 p-0 m-0 text-[0.60rem]">
                              #BATCH-{value?.inventory?.number || value?.description?.number}
                            </div>
                            <div className="text-gray-500 p-0 m-0 text-[0.60rem]">
                              {value?.expiry_date
                                ? `Expiry : ${formatDateDDMMYYYY(value?.expiry_date)}`
                                : ""}
                            </div>
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.unit_name}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.requested_quantity}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.issued_quantity}
                          </td>
                          <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.purchase_price?.toFixed(3)}
                          </td>
                          <td className="text-center leading-[0.75rem] align-top">
                            <div className="text-[0.60rem]">{value?.tax || 0}%</div>
                            <div className="text-[0.60rem] text-gray-500">
                              {value?.tax_amount?.toFixed(3) || "0.000"}
                            </div>
                          </td>
                          <td className="text-right text-[0.60rem] leading-[0.75rem] align-top">
                            {value?.total?.toFixed(3)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot className="text-xs text-medium leading-[0.75rem]">
                    <tr>
                      <th colSpan={6}></th>
                      <th className="font-normal text-right p-[4px]">
                        Subtotal
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {data?.subtotal?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={6}></th>
                      <th className="font-normal text-right p-[4px]">
                        VAT
                      </th>
                      <td className="font-normal text-right p-[4px]">
                        {data?.taxamount?.toFixed(3)}
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={6}></th>
                      <th className="font-normal text-right text-white bg-black p-[4px]">
                        Total
                      </th>
                      <td className="font-normal text-right text-white bg-black p-[4px]">
                        {data?.total?.toFixed(3)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Loadercomponent>
    </div>
  );
};

export default MaterialIssueView;